import { type CanBeChartedProperty } from '@principle-theorem/reporting';

export class IncomeMeasure {
  constructor(
    public measure: CanBeChartedProperty,
    public isNegativeValue: boolean = false
  ) {}
}
